<script lang="ts" setup>
import { watch, onUnmounted } from 'vue';
import { useFormStore } from '../../store/useFormStore';
import { normalizeFormData } from '../../types/repeatRules';
import type { Section } from '../../types/formTypeStructure';

interface Props {
  formId: string;
  sections: Section[];
  formValues: Record<string, any>;
}

const props = defineProps<Props>();
const formStore = useFormStore();

const syncFormData = (data: Record<string, any>) => {
  // Vérifier si le formulaire a été explicitement supprimé
  const isFormCleared = localStorage.getItem('form-cleared-' + props.formId) === 'true';
  
  // Si le formulaire a été supprimé, ne pas synchroniser du tout
  if (isFormCleared) {
    console.log('🚫 [FormSyncComponent] Synchronisation bloquée - formulaire supprimé');
    return;
  }
  
  const normalizedData = normalizeFormData(data, props.sections);
  formStore.setAllFormValues(props.formId, normalizedData);
  console.log('💾 [FormSyncComponent] Données synchronisées avec le store');
};

// Observer les changements de formValues
watch(
  () => props.formValues,
  (newValues) => {
    syncFormData(newValues);
  },
  { deep: true, immediate: false }
);
</script>

<template>
  <!-- Composant invisible qui synchronise les données -->
</template>

